export enum ActiveInactiveEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}

export const activeInactiveEnumDisplay = {
    [ActiveInactiveEnum.ACTIVE]: 'Active',
    [ActiveInactiveEnum.INACTIVE]: 'Inactive'
};
